import { NewWindow } from "../../../../src/components";
import * as React from 'react';
export default {
  NewWindow,
  React
};